import React, { useState } from "react"
import PropTypes from "prop-types"
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Alert,
  Spinner,
  FormGroup,
  Label,
  Input,
  InputGroup,
  InputGroupText,
} from "reactstrap"

//i18n
import { withTranslation } from "react-i18next"
// Redux
import { connect } from "react-redux"
import { Link, useNavigate } from "react-router-dom"
import withRouter from "../../Common/withRouter"
import axiosClient from "../../../helpers/axiosClient"

const ProfileMenu = props => {
  const [menu, setMenu] = useState(false)
  const { empresaSeleccionada, user } = props
  const navigate = useNavigate()

  // Change password modal
  const [pwdModalOpen, setPwdModalOpen] = useState(false)
  const [currentPassword, setCurrentPassword] = useState("")
  const [newPassword, setNewPassword] = useState("")
  const [confirmPassword, setConfirmPassword] = useState("")
  const [pwdLoading, setPwdLoading] = useState(false)
  const [pwdError, setPwdError] = useState("")
  const [pwdSuccess, setPwdSuccess] = useState("")
  const [showCurrentPwd, setShowCurrentPwd] = useState(false)
  const [showNewPwd, setShowNewPwd] = useState(false)
  const [showConfirmPwd, setShowConfirmPwd] = useState(false)


  const openPwdModal = () => {
    setCurrentPassword("")
    setNewPassword("")
    setConfirmPassword("")
    setPwdError("")
    setPwdSuccess("")
    setShowCurrentPwd(false)
    setShowNewPwd(false)
    setShowConfirmPwd(false)
    setPwdModalOpen(true)
    setMenu(false)
  }

  const closePwdModal = () => {
    if (!pwdLoading) setPwdModalOpen(false)
  }

  const handleChangePassword = async () => {
    setPwdError("")
    setPwdSuccess("")

    if (!currentPassword) {
      setPwdError("Ingrese su contraseña actual")
      return
    }
    if (!newPassword || newPassword.length < 6) {
      setPwdError("La nueva contraseña debe tener al menos 6 caracteres")
      return
    }
    if (newPassword !== confirmPassword) {
      setPwdError("Las contraseñas no coinciden")
      return
    }
    if (currentPassword === newPassword) {
      setPwdError("La nueva contraseña debe ser diferente a la actual")
      return
    }

    setPwdLoading(true)
    try {
      await axiosClient.put("auth/change-password", {
        currentPassword,
        newPassword,
      })
      setPwdSuccess("Contraseña cambiada exitosamente. Redirigiendo al login...")
      setTimeout(() => {
        localStorage.removeItem("authUser")
        localStorage.removeItem("empresaSeleccionada")
        navigate("/login")
      }, 2000)
    } catch (err) {
      const msg = err.response?.data?.message || "Error al cambiar la contraseña"
      setPwdError(typeof msg === "string" ? msg : JSON.stringify(msg))
    } finally {
      setPwdLoading(false)
    }
  }

  const labelStyle = { fontWeight: 600, fontSize: "0.85rem", color: "#334155", marginBottom: 4 }
  const inputStyle = { borderRadius: 8, fontSize: "0.9rem" }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={menu}
        toggle={() => setMenu(!menu)}
        className="d-inline-block"
      >
        <DropdownToggle
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
          tag="button"
          style={{ padding: "0 4px", lineHeight: 1 }}
        >
          <i className="mdi mdi-chevron-down" style={{ fontSize: 18, color: "#64748b" }} />
        </DropdownToggle>
        <DropdownMenu className="dropdown-menu-end">
          {empresaSeleccionada && (
            <React.Fragment>
              <div className="dropdown-item-text">
                <small className="text-muted">Empresa actual:</small>
                <br />
                <strong style={{ fontSize: "0.85rem" }}>
                  {empresaSeleccionada.nombre}
                </strong>
              </div>
              <div className="dropdown-divider" />
            </React.Fragment>
          )}
          {user && (
            <React.Fragment>
              <div className="dropdown-item-text">
                <small className="text-muted">Sesión:</small>
                <br />
                <span style={{ fontSize: "0.85rem" }}>
                  {user.nombre} {user.apellido}
                </span>
                <br />
                <small className="text-muted">{user.email}</small>
              </div>
              <div className="dropdown-divider" />
            </React.Fragment>
          )}
          <Link to="/seleccionar-empresa" className="dropdown-item">
            <i className="mdi mdi-swap-horizontal font-size-17 text-muted align-middle me-1" />
            <span>Cambiar Empresa</span>
          </Link>
          <button className="dropdown-item" onClick={openPwdModal} style={{ border: "none", background: "none", width: "100%", textAlign: "left", cursor: "pointer" }}>
            <i className="mdi mdi-lock-outline font-size-17 text-muted align-middle me-1" />
            <span>Cambiar Contraseña</span>
          </button>
          <div className="dropdown-divider" />
          <Link to="/logout" className="dropdown-item text-danger">
            <i className="mdi mdi-power font-size-17 text-muted align-middle me-1 text-danger" />
            <span>{props.t("Logout")}</span>
          </Link>
        </DropdownMenu>
      </Dropdown>

      {/* ── Modal: Cambiar Contraseña ── */}
      <Modal isOpen={pwdModalOpen} toggle={closePwdModal} centered>
        <ModalHeader toggle={closePwdModal}>
          <i className="mdi mdi-lock-outline me-2" style={{ color: "#556ee6" }} />
          Cambiar Contraseña
        </ModalHeader>
        <ModalBody>
          {pwdError && (
            <Alert color="danger" className="mb-3">
              <i className="mdi mdi-alert-circle me-1" />{pwdError}
            </Alert>
          )}
          {pwdSuccess && (
            <Alert color="success" className="mb-3">
              <i className="mdi mdi-check-circle me-1" />{pwdSuccess}
            </Alert>
          )}

          <FormGroup>
            <Label style={labelStyle}>Contraseña Actual</Label>
            <InputGroup>
              <Input
                type={showCurrentPwd ? "text" : "password"}
                style={inputStyle}
                value={currentPassword}
                onChange={e => setCurrentPassword(e.target.value)}
                placeholder="Ingrese su contraseña actual"
                disabled={pwdLoading || !!pwdSuccess}
              />
              <InputGroupText
                style={{ cursor: "pointer", borderRadius: "0 8px 8px 0" }}
                onClick={() => setShowCurrentPwd(!showCurrentPwd)}
              >
                <i className={`mdi mdi-eye${showCurrentPwd ? "-off" : ""}-outline`} />
              </InputGroupText>
            </InputGroup>
          </FormGroup>

          <FormGroup>
            <Label style={labelStyle}>Nueva Contraseña</Label>
            <InputGroup>
              <Input
                type={showNewPwd ? "text" : "password"}
                style={inputStyle}
                value={newPassword}
                onChange={e => setNewPassword(e.target.value)}
                placeholder="Mínimo 6 caracteres"
                disabled={pwdLoading || !!pwdSuccess}
              />
              <InputGroupText
                style={{ cursor: "pointer", borderRadius: "0 8px 8px 0" }}
                onClick={() => setShowNewPwd(!showNewPwd)}
              >
                <i className={`mdi mdi-eye${showNewPwd ? "-off" : ""}-outline`} />
              </InputGroupText>
            </InputGroup>
            {newPassword && newPassword.length < 6 && (
              <small className="text-danger">Mínimo 6 caracteres</small>
            )}
          </FormGroup>

          <FormGroup className="mb-0">
            <Label style={labelStyle}>Confirmar Nueva Contraseña</Label>
            <InputGroup>
              <Input
                type={showConfirmPwd ? "text" : "password"}
                style={inputStyle}
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                placeholder="Repita la nueva contraseña"
                disabled={pwdLoading || !!pwdSuccess}
              />
              <InputGroupText
                style={{ cursor: "pointer", borderRadius: "0 8px 8px 0" }}
                onClick={() => setShowConfirmPwd(!showConfirmPwd)}
              >
                <i className={`mdi mdi-eye${showConfirmPwd ? "-off" : ""}-outline`} />
              </InputGroupText>
            </InputGroup>
            {confirmPassword && newPassword !== confirmPassword && (
              <small className="text-danger">Las contraseñas no coinciden</small>
            )}
          </FormGroup>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={closePwdModal} disabled={pwdLoading} style={{ borderRadius: 8 }}>
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={handleChangePassword}
            disabled={pwdLoading || !!pwdSuccess}
            style={{ borderRadius: 8, minWidth: 160 }}
          >
            {pwdLoading ? (
              <><Spinner size="sm" className="me-1" />Cambiando...</>
            ) : (
              <><i className="mdi mdi-lock-check me-1" />Cambiar Contraseña</>
            )}
          </Button>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  )
}

ProfileMenu.propTypes = {
  success: PropTypes.any,
  t: PropTypes.any,
  empresaSeleccionada: PropTypes.object,
  user: PropTypes.object,
}

const mapStatetoProps = state => {
  const { error, success } = state.Profile
  return {
    error,
    success,
    empresaSeleccionada: state.Login.empresaSeleccionada,
    user: state.Login.user,
  }
}

export default withRouter(
  connect(mapStatetoProps, {})(withTranslation()(ProfileMenu)),
)
